import { render } from "./CometChatIncomingCall.vue?vue&type=template&id=45b5858c&scoped=true"
import script from "./CometChatIncomingCall.vue?vue&type=script&lang=js"
export * from "./CometChatIncomingCall.vue?vue&type=script&lang=js"

import "./CometChatIncomingCall.vue?vue&type=style&index=0&id=45b5858c&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b5858c"]])

export default __exports__